import get from 'lodash/get';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';

import { ACCOUNT_SETTINGS_PAGES } from '../../routing/routeConfiguration';
import {
  $subscriptionInfo,
} from '../../ducks/user.duck';

import {
  getIsShowManageTeamNav,
} from '../../util/subscription';

import { LinkTabNavHorizontal } from '../../components';

import css from './UserNav.module.css';

const UserNavComponent = props => {
  const {
    className,
    rootClassName,
    selectedPageName,
    currentUser,
    subscriptionInfo,
  } = props;

  const classes = classNames(rootClassName || css.root, className);
  const isAdmin = get(currentUser, 'attributes.profile.metadata.isAdmin', false);

  const tabs = [
    {
      text: <FormattedMessage id="ManageListingsPage.yourListings" />,
      selected: selectedPageName === 'ManageListingsPage',
      linkProps: {
        name: 'ManageListingsPage',
      },
    },
    {
      text: <FormattedMessage id="FavoritesPage.title" />,
      selected: selectedPageName === 'FavoritesPage',
      linkProps: {
        name: 'FavoritesPage',
      },
    },
    {
      text: <FormattedMessage id="SavedSearchPage.title" />,
      selected: selectedPageName === 'SavedSearchPage',
      linkProps: {
        name: 'SavedSearchPage',
      },
    },
    ...(isAdmin ? [{
      text: <FormattedMessage id="RegistrationPhotosPage.title" />,
      selected: selectedPageName === 'RegistrationPhotosPage',
      linkProps: {
        name: 'RegistrationPhotosPage',
      },
    }] : []),
    ...(getIsShowManageTeamNav(currentUser, subscriptionInfo.entitlements) ? [{
      text: <FormattedMessage id="ManageTeamPage.title" />,
      selected: selectedPageName === 'ManageTeamPage',
      linkProps: {
        name: 'ManageTeamPage',
      },
    }] : []),
    {
      text: <FormattedMessage id="DashboardPage.title" />,
      selected: selectedPageName === 'DashboardPage',
      linkProps: {
        name: 'DashboardPage',
      },
    },
    {
      text: <FormattedMessage id="ManageListingsPage.profileSettings" />,
      selected: selectedPageName === 'ProfileSettingsPage',
      disabled: false,
      linkProps: {
        name: 'ProfileSettingsPage',
      },
    },
    {
      text: <FormattedMessage id="ManageListingsPage.accountSettings" />,
      selected: ACCOUNT_SETTINGS_PAGES.includes(selectedPageName),
      disabled: false,
      linkProps: {
        name: 'ContactDetailsPage',
      },
    },
  ];

  return (
    <LinkTabNavHorizontal className={classes} tabRootClassName={css.tab} tabs={tabs} skin="dark" />
  );
};

UserNavComponent.defaultProps = {
  className: null,
  rootClassName: null,
};

const { string } = PropTypes;

UserNavComponent.propTypes = {
  className: string,
  rootClassName: string,
  selectedPageName: string.isRequired,
};

const mapStateToProps = state => {
  const {
    currentUser,
  } = state.user;

  return {
    currentUser,
    subscriptionInfo: $subscriptionInfo(state),
  };
}

const UserNav = compose(
  withRouter,
  connect(
    mapStateToProps
  )
)(UserNavComponent);

export default UserNav;
